export enum HeaderType {
	DEFAULT = "default",
	WITH_SIDEBAR = "withSidebar",
	EMPTY = "empty",
}

export enum HeaderTargetType {
	SPORTS = "sports",
	LIVE = "live",
}
